import { Box, Input, Label, useColorMode } from 'theme-ui';

const CustomFilterSelect = ({ value, search, handleSearch, projectManagerList, flagValue, checkProjectManagerSelected, toggleManagerHandle, handleAllManagerSelection, managerDataKey, loading }: { value: any, search: any, handleSearch: any, projectManagerList: any, flagValue: any, checkProjectManagerSelected: any, toggleManagerHandle: any, handleAllManagerSelection: any, managerDataKey: string, loading: boolean }) => {
    const handleCheck = () => {
        const allManagerIds = projectManagerList.map((manager: any) => manager._id);
        const isAllManagersSelected = allManagerIds.every((id: string) =>
            value[managerDataKey].includes(id)
        );
        return isAllManagersSelected
    }
    const [colorMode] = useColorMode();
    const bgFilter = colorMode === 'light' ? "#ffffff" : "#323c56";
    const titleHeader = colorMode === 'light' ? "#453521" : "#f8f9fa";
    return (
        <div>
            <Box sx={{ position: 'absolute', gap: '8px', right: 0, zIndex: 1, backgroundColor: bgFilter, boxShadow: '0px 0px 16px rgba(0,0,0,0.06)', borderRadius: '4px', fontSize: '15px', padding: "8px" }}>
                <Box>
                    <Box sx={{ display: "flex", gap: "8px", padding: "5px" }}>
                        <input type='checkbox' checked={handleCheck()} onChange={() => !loading && handleAllManagerSelection(managerDataKey, flagValue)} style={{ cursor: "pointer" }} />
                        <Input name='search' placeholder='Enter name' sx={{ width: "250px", height: "30px", border: "1px solid rgba(141, 141, 141, 0.2)", backgroundColor: "#fff" }} value={search} onChange={!loading && handleSearch} />
                    </Box>
                    <Box sx={{ maxHeight: "200px", overflowY: "scroll" }}>
                        {projectManagerList.map((manager: { _id: string, FirstName: string, LastName: string }) => (
                            <Label key={manager._id} className="text-hover" sx={{ cursor: "pointer", padding: '5px', color: titleHeader, '&:hover': { backgroundColor: colorMode === 'light' ? '#f5f5f5' : '#333333' } }}>
                                <input type='checkbox' checked={checkProjectManagerSelected(manager._id)} onChange={() => !loading && toggleManagerHandle(managerDataKey, manager._id, flagValue)} style={{ cursor: "pointer" }} />
                                {manager.FirstName + " " + manager.LastName}
                            </Label>
                        ))}
                    </Box>
                </Box>
            </Box>
        </div>
    )
}

export default CustomFilterSelect
